import Route from 'cio/pods/base/overview/route';
import { inject as service } from '@ember/service';
import CampaignSubscriptionsService from 'cio/services/campaign-subscriptions';

export default class OverviewRoute extends Route {
  @service campaignSubscriptions!: CampaignSubscriptionsService;

  afterModel(model: any, transition: any) {
    super.afterModel(model, transition);
    return this.campaignSubscriptions.getSubscriptions.perform();
  }
}
